var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilterDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2,
    height: 12,
    viewBox: "0 0 2 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395",
    transform: "translate(-246 -176.608)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(246 176.608)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(246 181.608)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(246 186.608)",
    fill: "#5d5d5d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterDots);
export default __webpack_public_path__ + "static/media/icon-filterDots.17e0032d19b533179d0d8ea08324f2d3.svg";
export { ForwardRef as ReactComponent };